<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useItemPrototypesStore } from "~/stores/item-prototypes";
import { useItemsStore } from "~/stores/items";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const alertStore = useAlertStore();
const { itemsConfirmDeleteMultiple } = useModalStore();
const itemPrototypesStore = useItemPrototypesStore();
const itemsStore = useItemsStore();

const submitItemDelete = async () => {
	const { ids, itemPrototype } = itemsConfirmDeleteMultiple.itemGroup;

	itemsConfirmDeleteMultiple.closeModal();

	const loadingAlertId = alertStore.createLoadingAlert();
	const alertMessage = {
		id: loadingAlertId,
		title: `${t("COMPONENTS.ITEMS.CONFIRM_DELETE_MULTIPLE.loadingAlert.title", { total: itemsCountToDelete.value })}`
	};
	alertStore.updateLoadingAlert(alertMessage);

	const promises = ids.map(id => itemsStore.deleteById(id));
	await Promise.all(promises);

	alertStore.removeLoadingAlert(loadingAlertId);

	itemsStore.getAll({}, itemsStore.recentGetAllQuery);

	alertStore.addAlert({
		title: t("COMPONENTS.ITEMS.CONFIRM_DELETE_MULTIPLE.alert.title"),
		description: t("COMPONENTS.ITEMS.CONFIRM_DELETE_MULTIPLE.alert.description", { count: itemsCountToDelete.value }),
		status: ALERT_STATUS.SUCCESS
	});

	itemPrototypesStore.currentItemPrototype = await itemPrototypesStore.getById(itemPrototype.itemPrototype.id);
};

const itemsCountToDelete = computed(() => itemsConfirmDeleteMultiple.itemGroup.ids.length);
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ITEMS.CONFIRM_DELETE_MULTIPLE.title')"
		:description="$t('COMPONENTS.ITEMS.CONFIRM_DELETE_MULTIPLE.description', {count: itemsCountToDelete})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="itemsConfirmDeleteMultiple.closeModal"
		@submit="submitItemDelete"
	/>
</template>
